import React from 'react';
import Avatar from 'components/Avatar/Avatar';
import Currency from 'components/Currency/Currency';
import moment from 'moment';
import classnames from 'classnames';

const ExpandedCurrency = ({ text, userValue, unredeemed = false }) => (
  <div className="flex-row flex-expand user-expanded-text">
    <div className="flex-expand">{text}</div>
    <div
      className={classnames('flex-justify-end', {
        'gift gift-unredeemed': unredeemed,
      })}
    >
      {<Currency amount={userValue ? Math.abs(userValue) : 0} />}
      {unredeemed && (
        <span className="gift-unredeemed gift-unredeemed-text">
          &nbsp;(unredeemed)
        </span>
      )}
    </div>
  </div>
);

const ExpandedDate = ({ text, date }) => (
  <div className="flex-row flex-expand is-hidden-tablet">
    <div className="user-expanded-text flex-expand">{text}</div>
    <div className="user-expanded-text flex-justify-end">
      <span>{date ? moment(date).format('M/D/Y') : 'Waiting'}</span>
    </div>
  </div>
);

const User = ({ original, isExpanded }) => (
  <div className="flex-row col-user-container">
    <div className="flex-column flex-expand min-width-reset">
      <div className="flex-row items-center">
        <Avatar avatar={original.avatar} />
        <div className="flex-column flex-expand col-user-details">
          {original.firstName !== null && original.lastName !== null ? (
            <div>
              <div className="col-user-name">{`${original.firstName} ${
                original.lastName
              }${
                original.companyRoles?.includes('admin') ? ' - Admin' : ''
              }`}</div>
              <div className="col-user-email">{original.email}</div>
            </div>
          ) : (
            <div className="col-user-name">{original.email}</div>
          )}
        </div>
      </div>
      {isExpanded && (
        <div className="is-hidden-desktop is-expanded flex-column flex-expand">
          <ExpandedCurrency
            text="Gifts"
            userValue={original.giftAmount}
            unredeemed={!original.companyGiftTotal}
          />
          <ExpandedCurrency
            text="Eligible Match"
            userValue={original.eligibleMatch}
          />
          <ExpandedDate text="Redeemed" date={original.redeemedDate} />
          <ExpandedDate text="Invited Date" date={original.invitedDate} />
        </div>
      )}
    </div>
  </div>
);

export default User;
